/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Render_Audio_Action_NameInputs */



/**
* | output |
* | --- |
* | "rendering audio" |
*
* @param {Render_Audio_Action_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const render_audio_action_name = /** @type {((inputs?: Render_Audio_Action_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Render_Audio_Action_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("rendu audio")
	if (locale === "de") return /** @type {LocalizedString} */ ("Audiowiedergabe")
	if (locale === "it") return /** @type {LocalizedString} */ ("rendering audio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("рендеринг звука")
	if (locale === "es") return /** @type {LocalizedString} */ ("renderizado de audio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("渲染音频")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オーディオのレンダリング")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो रेंडरिंग")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("renderização de áudio")
	return /** @type {LocalizedString} */ ("rendering audio")
});